import { css, cx } from 'linaria';
import { getObjectWithValidKeysOnly } from 'common/utilities';
import { openWindow } from 'common/utilities';
import { topTooltipDelayed } from 'components/tooltip/tooltip';
import { FacebookColorIcon } from '@pocket/web-ui';
import { TwitterColorIcon } from '@pocket/web-ui';
import { LinkedinMonoIcon } from '@pocket/web-ui';
import { RedditMonoIcon } from '@pocket/web-ui';
import { BufferIcon } from '@pocket/web-ui';
export const socialButtonStyles = "sdsmk1n";
const SocialNetworks = {
  facebook: {
    width: 550,
    height: 400,
    params: ['u', 'quote'],
    // u === url
    shareUrl: 'https://www.facebook.com/sharer/sharer.php',
    icon: FacebookColorIcon
  },
  twitter: {
    width: 550,
    height: 400,
    params: ['url', 'text', 'via'],
    // text === title
    shareUrl: 'https://twitter.com/share',
    icon: TwitterColorIcon
  },
  linkedin: {
    width: 750,
    height: 600,
    params: ['url', 'title', 'summary', 'source'],
    shareUrl: 'https://linkedin.com/shareArticle',
    icon: LinkedinMonoIcon
  },
  reddit: {
    width: 660,
    height: 460,
    params: ['url', 'title'],
    shareUrl: 'https://www.reddit.com/submit',
    icon: RedditMonoIcon
  },
  buffer: {
    width: 750,
    height: 550,
    params: ['url', 'text'],
    // text === quote || excerpt
    shareUrl: 'https://bufferapp.com/add',
    icon: BufferIcon
  }
};

function buildLink(network, rest) {
  const {
    params,
    shareUrl
  } = SocialNetworks[network];
  const tmpParams = params.reduce((obj, key) => ({ ...obj,
    [key]: rest[key]
  }), {});
  const searchParams = getObjectWithValidKeysOnly(tmpParams);
  const url = new URL(shareUrl);
  url.search = new URLSearchParams(searchParams);
  return url.href;
}

export const SocialButton = ({
  network,
  label,
  onSocialShare,
  ...rest
}) => {
  const {
    width,
    height,
    icon
  } = SocialNetworks[network];
  const link = buildLink(network, rest);
  const opts = {
    name: network,
    width,
    height
  };
  const SocialIcon = icon;

  const callbackHandler = () => onSocialShare(network);

  const clickHandler = e => {
    e.preventDefault();
    openWindow(link, opts, callbackHandler);
  };

  return <button onClick={clickHandler} className={cx(socialButtonStyles, topTooltipDelayed)} aria-label={label} data-tooltip={label} data-cy={`share-${network}`}>
      <SocialIcon />
    </button>;
};

require("./social-button.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./social-button.js");